export function Logo({ size = "md", variant = "dark" }) {
  const wrap = size === "lg" ? "text-3xl" : size === "sm" ? "text-lg" : "text-2xl";
  const color = variant === "light" ? "text-white" : "text-slate-900";
  const sub = variant === "light" ? "text-slate-400" : "text-slate-500";
  const bar = variant === "light" ? "bg-white" : "bg-slate-900";
  return (
    <div className="inline-flex flex-col" data-testid="brand-logo">
      <span className={`font-display font-bold tracking-tight ${wrap} ${color}`}>D4PS</span>
      <span className={`text-[10px] font-semibold tracking-[0.18em] ${sub}`}>
        COURIERS &amp; LOGISTICS
      </span>
      <span className={`mt-1 h-[2px] w-10 ${bar}`} />
    </div>
  );
}
